<template>
  <section class="section">
    <div class="content">
      <h1 class="title">
        Vocabulary
      </h1>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column">
        <input type="text" class="input" v-model="query" placeholder="Type to search">
      </div>
    </div>

    <table class="table is-fullwidth is-bordered is-striped">
      <thead>
        <tr>
          <th>Type</th>
          <th>Original</th>
          <th>English</th>
          <th>Portuguese</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(therm, key) in therms" v-bind:key="key">
          <td>{{ therm.type }}</td>
          <td>{{ therm.original }}</td>
          <td>{{ therm.english }}</td>
          <td>{{ therm.portuguese }}</td>
        </tr>
      </tbody>
    </table>

    <p>
      <a href="https://shreevatsa.appspot.com/sanskrit/transliterate.html">Devanagari transliteration</a>
    </p>
  </section>
</template>

<script>
import BackButton from '@/components/pages/BackButton'

/* eslint-disable */
const therms = [
  { original: 'Βάκχος', english: 'Bacchus', portuguese: 'Baco', type: 'Mythology' },
  { original: 'Πάν', english: 'Pan', portuguese: 'Pã', type: 'Mythology' },
  { original: 'Cerēs', english: 'Ceres', portuguese: 'Ceres', type: 'Mythology' },
  { original: 'Diana', english: 'Diana', portuguese: 'Diana', type: 'Mythology' },
  { original: 'Χρόνος', english: 'Chronos', portuguese: 'Cronos', type: 'Mythology' },
  { original: 'Περσεφόνη', english: 'Persephone', portuguese: 'Perséfone', type: 'Mythology' },
  { original: 'Οὐρανός', english: 'Uranus', portuguese: 'Urano', type: 'Mythology' },
  { original: 'Ἄρτεμις', english: 'Artemis', portuguese: 'Ártemis', type: 'Mythology' },
  { original: 'Ἄρης', english: 'Ares', portuguese: 'Ares', type: 'Mythology' },
  { original: 'Αὐγοειδής', english: 'Augoeides', portuguese: 'Augoeides', type: 'Other' },
  { original: 'Botrychium lunaria', english: 'moon-wort', portuguese: 'lunária', type: 'Plant' },
  { original: 'Teucrium scorodonia', english: 'pale herb', portuguese: 'escorodónia', type: 'Plant' },
  { original: 'ॐ', english: 'Aum', portuguese: 'Auṃ', type: 'Hinduism' },
  { original: 'प्रणव', english: 'Pranava', portuguese: 'Praṇava', type: 'Hinduism' },
  { original: 'प्राणा', english: 'Prana', portuguese: 'Prāṇā', type: 'Hinduism' },
  { original: 'यम', english: 'Yama', portuguese: 'Yama', type: 'Hinduism' },
  { original: 'नियम', english: 'Niyama', portuguese: 'Niyama', type: 'Hinduism' },
  { original: 'आसन', english: 'Asana', portuguese: 'Āsana', type: 'Hinduism' },
  { original: 'प्राणायाम', english: 'Pranayama', portuguese: 'Prāṇāyāma', type: 'Hinduism' },
  { original: 'धारणा', english: 'Dharana', portuguese: 'Dhāraṇā', type: 'Hinduism' },
  { original: 'प्रत्याहार', english: 'Pratyahara', portuguese: 'Pratyāhāra', type: 'Hinduism' },
  { original: 'ध्यान', english: 'Dhyana', portuguese: 'Dhyāna', type: 'Hinduism' },
  { original: 'समाधि', english: 'Samadhi', portuguese: 'Samādhi', type: 'Hinduism' },
  { original: 'अत्मदर्शन', english: 'Atmadarshana', portuguese: 'Atmadarśana', type: 'Hinduism' },
  { original: 'आत्मन्', english: 'Atman', portuguese: 'Ātman', type: 'Hinduism' },
  { original: 'विवेक', english: 'Viveka', portuguese: 'Viveka', type: 'Hinduism' },
  { original: 'वैराग्य', english: 'Vairagya', portuguese: 'Vairāgya', type: 'Hinduism' },
  { original: 'मुद्रा', english: 'Mudra', portuguese: 'Mudrā', type: 'Hinduism' },
  { original: 'अहिंसा', english: 'Ahinsa', portuguese: 'Ahiṃsā', type: 'Hinduism' },
  { original: 'सत्य', english: 'Satya', portuguese: 'Satya', type: 'Hinduism' },
  { original: 'अस्तेय', english: 'Asteya', portuguese: 'Asteya', type: 'Hinduism' },
  { original: 'ब्रह्मचर्य', english: 'Brahmacharya', portuguese: 'Brahmacharya', type: 'Hinduism' },
  { original: 'अपरिग्रह', english: 'Aparigraha', portuguese: 'Aparigraha', type: 'Hinduism' },
  { original: 'शौच', english: 'S\'ancha', portuguese: 'Śauca', type: 'Hinduism' },
  { original: 'सन्तोष', english: 'Santosha', portuguese: 'Santoṣa', type: 'Hinduism' },
  { original: 'तपस्', english: 'Papasaya', portuguese: 'Tapas', type: 'Hinduism' },
  { original: 'स्वाध्याय', english: 'Swadhyaya', portuguese: 'Svādhyāya', type: 'Hinduism' },
  { original: 'ओजस्', english: 'Ojas', portuguese: 'Ojas', type: 'Hinduism' },
  { original: 'ईश्वरप्रणिधान', english: 'Iswara pranidhana', portuguese: 'Īśvarapraṇidhāna', type: 'Hinduism' },
  { original: 'राजयोग', english: 'Raja Yoga', portuguese: 'Rāja Yoga', type: 'Hinduism' },
  { original: 'भक्तियोग', english: 'Bhakti Yoga', portuguese: 'Bhakti Yoga', type: 'Hinduism' },
  { original: 'ज्ञानयोग', english: 'Gnana Yoga', portuguese: 'Jñāna Yoga', type: 'Hinduism' },
  { original: 'ज्ञानयोग', english: 'Jnana Yoga', portuguese: 'Jñāna Yoga', type: 'Hinduism' },
  { original: 'कर्मयोग', english: 'Karma Yoga', portuguese: 'Karma Yoga', type: 'Hinduism' },
  { original: 'हठयोग', english: 'Hatha Yoga', portuguese: 'Haṭha Yoga', type: 'Hinduism' },
  { original: 'परन्तप', english: 'Parantapa', portuguese: 'Parantapa', type: 'Hinduism' },
  { original: 'पार्थ', english: 'Partha', portuguese: 'Pārtha', type: 'Hinduism' },
  { original: 'संप्रज्ञात', english: 'Sampradnyata', portuguese: 'Saṃprajñāta', type: 'Hinduism' },
  { original: 'कर्म', english: 'Karma', portuguese: 'Karma', type: 'Hinduism' },
  { original: 'चेला', english: 'Chela', portuguese: 'Celā', type: 'Hinduism' },
  { original: 'मठ', english: 'Matha', portuguese: 'Maṭha', type: 'Hinduism' },
  { original: 'नाडी', english: 'Nadi', portuguese: 'Nāḍī', type: 'Hinduism' },
  { original: 'इडा', english: 'Ida', portuguese: 'Iḍā', type: 'Hinduism' },
  { original: 'पिङ्गल', english: 'Pingala', portuguese: 'Piṅgala', type: 'Hinduism' },
  { original: 'सुषुम्णा', english: 'Sushumna', portuguese: 'Suṣumṇā', type: 'Hinduism' },
  { original: 'कुण्डलिनी', english: 'Kundalini', portuguese: 'Kuṇḍalinī', type: 'Hinduism' },
  { original: 'तत्व', english: 'Tattwa', portuguese: 'Tatva', type: 'Hinduism' },
  { original: 'आकाश', english: 'Akasha', portuguese: 'Ākāśa', type: 'Hinduism' },
  { original: 'वायु', english: 'Vayu', portuguese: 'Vāyu', type: 'Hinduism' },
  { original: 'पृथ्वी', english: 'Prithivi', portuguese: 'Pṛthvī', type: 'Hinduism' },
  { original: 'तेज', english: 'Tejas', portuguese: 'Teja', type: 'Hinduism' },
  { original: 'आप', english: 'Apas', portuguese: 'Āpa', type: 'Hinduism' },
  { original: 'कुम्भक', english: 'Kumbhaka', portuguese: 'Kumbhaka', type: 'Hinduism' },
  { original: 'चक्र', english: 'Chakra', portuguese: 'Cakra', type: 'Hinduism' },
  { original: 'सहस्रार', english: 'Sahasrara', portuguese: 'Sahasrāra', type: 'Hinduism' },
  { original: 'आज्ञा', english: 'Ajna', portuguese: 'Ājñā', type: 'Hinduism' },
  { original: 'विशुद्ध', english: 'Vishuddha', portuguese: 'Viśuddha', type: 'Hinduism' },
  { original: 'अनाहत', english: 'Anahata', portuguese: 'Anāhata', type: 'Hinduism' },
  { original: 'मणिपूर', english: 'Manipura', portuguese: 'Maṇipūra', type: 'Hinduism' },
  { original: 'स्वाधिष्ठान', english: 'Svadhishthana', portuguese: 'Svādhiṣṭhāna', type: 'Hinduism' },
  { original: 'मूलाधार', english: 'Muladhara', portuguese: 'Mūlādhāra', type: 'Hinduism' },
  { original: 'योनि', english: 'Yoni', portuguese: 'Yoni', type: 'Hinduism' },
  { original: 'लिङ्ग', english: 'Lingam', portuguese: 'Liṅga', type: 'Hinduism' },
  { original: 'नाद', english: 'Nada', portuguese: 'Nāda', type: 'Hinduism' },
  { original: 'तन्त्र', english: 'Tantra', portuguese: 'Tantra', type: 'Hinduism' },
  { original: 'बीज', english: 'Vija', portuguese: 'Bīja', type: 'Hinduism' },
  { original: 'शास्त्र', english: 'Shastra', portuguese: 'Śāstra', type: 'Hinduism' },

  { original: 'अपान', english: 'Apana', portuguese: 'Apāna', type: 'Hinduism' },
  { original: 'उदान', english: 'Udana', portuguese: 'Udāna', type: 'Hinduism' },
  { original: 'समान', english: 'Samana', portuguese: 'Samāna', type: 'Hinduism' },
  { original: 'व्यान', english: 'Vyana', portuguese: 'Vyāna', type: 'Hinduism' },

  { original: 'धौति', english: 'Dhauti', portuguese: 'Dhauti', type: 'Hinduism' },
  { original: 'बस्ति', english: 'Basti', portuguese: 'Basti', type: 'Hinduism' },
  { original: 'नेती', english: 'Neti', portuguese: 'Netī', type: 'Hinduism' },
  { original: 'त्राटक', english: 'Trataka', portuguese: 'Trāṭaka', type: 'Hinduism' },
  { original: 'नौलि', english: 'Nauli', portuguese: 'Nauli', type: 'Hinduism' },
  { original: 'कपालभाति', english: 'Kapalabhati', portuguese: 'Kapālabhāti', type: 'Hinduism' },

  { original: 'सिद्धासन', english: 'Siddhasana', portuguese: 'Siddhāsana', type: 'Hinduism' },
  { original: 'पद्मासन', english: 'Padmasana', portuguese: 'Padmāsana', type: 'Hinduism' },
  { original: 'उग्रासन', english: 'Ugrasana', portuguese: 'Ugrāsana', type: 'Hinduism' },
  { original: 'स्वस्तिकासन', english: 'Svastikasana', portuguese: 'Svastikāsana', type: 'Hinduism' },

  { original: 'अन्तःकरण', english: 'Antahkarana', portuguese: 'Antaḥkaraṇa', type: 'Hinduism' },
  { original: 'ब्रह्मन्', english: 'Brahman', portuguese: 'Brahman', type: 'Hinduism' },
  { original: 'बन्धूक', english: 'Bandhuk', portuguese: 'Bandhūka', type: 'Hinduism' },
  { original: 'परब्रह्मन्', english: 'Para Brahman', portuguese: 'Para Brahman', type: 'Hinduism' },
  { original: 'ब्रह्मरन्ध्र', english: 'Brahmarandhra', portuguese: 'Brahmarandhra', type: 'Hinduism' },
  { original: 'ब्रह्मचर्य', english: 'Brahmacharya', portuguese: 'Brahmacarya', type: 'Hinduism' },


  { original: 'सत्', english: 'Sat', portuguese: 'Sat', type: 'Hinduism' },
  { original: 'चित्', english: 'Chit', portuguese: 'Cit', type: 'Hinduism' },
  { original: 'आनन्द', english: 'Ananda', portuguese: 'Ānanda', type: 'Hinduism' },
  { original: 'अन्तःकरण', english: 'Anthakarana', portuguese: 'Antaḥkaraṇa', type: 'Hinduism' },
  { original: 'मनस्', english: 'Manas', portuguese: 'Manas', type: 'Hinduism' },
  { original: 'बुद्धि', english: 'Buddhi', portuguese: 'Buddhi', type: 'Hinduism' },
  { original: 'चित्तम्', english: 'Chittam', portuguese: 'Cittam', type: 'Hinduism' },
  { original: 'अहंकार', english: 'Ahankara', portuguese: 'Ahaṃkāra', type: 'Hinduism' },
  { original: 'ज्ञानेन्द्रिय', english: 'Gnanendriyam', portuguese: 'Jñānendriya', type: 'Hinduism' },
  { original: 'कर्मेन्द्रियम्', english: 'Karmendriyam', portuguese: 'Karmendriyam', type: 'Hinduism' },
  { original: 'कोश', english: 'Kos\'a', portuguese: 'Kośa', type: 'Hinduism' },
  { original: 'कोश', english: 'Kosha', portuguese: 'Kośa', type: 'Hinduism' },

  { original: 'अन्नमय कोश', english: 'Annamayakosha', portuguese: 'Annamaya Kośa', type: 'Hinduism' },
  { original: 'प्राणमय कोश', english: 'Pranayamakosha', portuguese: 'Prāṇamaya Kośa', type: 'Hinduism' },
  { original: 'मनोमय कोश', english: 'Manomayakosha', portuguese: 'Manomaya Kośa', type: 'Hinduism' },
  { original: 'विज्ञानमय कोश', english: 'Vinnanamayakosha', portuguese: 'Vijñānamaya Kośa', type: 'Hinduism' },
  { original: 'आनंदमय कोश', english: 'Anandamayakosha', portuguese: 'Ānaṃdamaya Kośa', type: 'Hinduism' },

  { original: 'स्थूलशरीर', english: 'Sthula Shirara', portuguese: 'Sthūla Śarīra', type: 'Hinduism' },
  { original: 'लिङ्गशरीर', english: 'Linga Shirara', portuguese: 'Liṅga Śarīra', type: 'Hinduism' },
  { original: 'करणशरीर', english: 'Karana Shirara', portuguese: 'Karaṇa Śarīra', type: 'Hinduism' },
  { original: 'सूक्ष्मशरीर', english: 'Sukshma Shirara', portuguese: 'Sūkṣma Śarīra', type: 'Hinduism' },

  { original: 'मन्त्र', english: 'Mantra', portuguese: 'Mantra', type: 'Hinduism' },
  { original: 'आनन्द', english: 'Ananda', portuguese: 'Ānanda', type: 'Hinduism' },
  { original: 'काली', english: 'Kali', portuguese: 'Kālī', type: 'Hinduism' },
  { original: 'गुरु', english: 'Guru', portuguese: 'Guru', type: 'Hinduism' },
  { original: 'लाख', english: 'Lak', portuguese: 'Lākh', type: 'Hinduism' },
  { original: 'लक्ष्मी', english: 'Lakshmi', portuguese: 'Lakṣmī', type: 'Hinduism' },
  { original: 'विष्णु', english: 'Vishnu', portuguese: 'Viṣṇu', type: 'Hinduism' },
  { original: 'शिव', english: 'Shiva', portuguese: 'Śiva', type: 'Hinduism' },
  { original: 'शक्ति', english: 'Shakti', portuguese: 'Śakti', type: 'Hinduism' },
  { original: 'भवानी', english: 'Bhavani', portuguese: 'Bhavānī', type: 'Hinduism' },
  { original: 'कृष्ण', english: 'Krishna', portuguese: 'Kṛṣṇa', type: 'Hinduism' },
  { original: 'गुण', english: 'Guna', portuguese: 'Guṇa', type: 'Hinduism' },
  { original: 'रजस्', english: 'Rajas', portuguese: 'Rajas', type: 'Hinduism' },
  { original: 'सत्व', english: 'Sattva', portuguese: 'Satva', type: 'Hinduism' },
  { original: 'तमस्', english: 'Tamas', portuguese: 'Tamas', type: 'Hinduism' },
  { original: 'योगी', english: 'Yogui', portuguese: 'Yogī', type: 'Hinduism' },
  { original: 'ॐ मणिपद्मे हूँ', english: 'Aum mani padme Hum', portuguese: 'Auṃ maṇi padme hūṃ', type: 'Hinduism' },
  { original: 'ॐ नमः वशि', english: 'Aum Shivaya Vashi', portuguese: 'Auṃ Śivāya Vaśi', type: 'Hinduism' },
  { original: 'ॐ नमः शिवाय', english: 'Aum Namah Shivaya', portuguese: 'Auṃ Namaḥ Śivāya', type: 'Hinduism' },
  { original: 'ओम् तत् सत्,', english: 'Aum Tat Sat', portuguese: 'Auṃ Tat Sat', type: 'Hinduism' },
  { original: '', english: 'Namo Shivaya namaha', portuguese: 'Namo Śivāya namaḥ', type: 'Hinduism' },
  { original: 'केशर', english: 'Keshara', portuguese: 'Keśara', type: 'Hinduism' },
  { original: 'अर्जुन', english: 'Arjuna', portuguese: 'Arjuna', type: 'Hinduism' },
  { original: 'भगवद् गीता', english: 'Baghavad Gita', portuguese: 'Bhagavad Gītā', type: 'Hinduism' },
  { original: 'शिवसंहिता', english: 'Shiva Samhita', portuguese: 'Śiva Saṃhitā', type: 'Hinduism' },
  { original: 'घेरंडसंहिता', english: 'Gheranda Samhita', portuguese: 'Gheraṃḍa Saṃhitā', type: 'Hinduism' },
  { original: 'हठयोगप्रदीपिका', english: 'Hatha Yoga Pradipika', portuguese: 'Haṭha Yoga Pradīpikā', type: 'Hinduism' },
  { original: 'क्षुरिक उपनिषद', english: 'Kshurika Upanishad', portuguese: 'Kṣurika Upaniṣada', type: 'Hinduism' },
  { original: 'श्वेताश्वतर उपनिषद्', english: 'Shvetashvatara Upanishad', portuguese: 'Śvetāśvatara Upaniṣada', type: 'Hinduism' },
  { original: 'गौणी', english: 'Gauni', portuguese: 'Gauṇī', type: 'Hinduism' },
  { original: 'परा', english: 'Para', portuguese: 'Parā', type: 'Hinduism' },
  { original: 'हठविद्या', english: 'Hatha Vidya', portuguese: 'Haṭha Vidyā', type: 'Hinduism' },
  { original: 'महासतिपट्ठान', english: 'Mahasatipatthana', portuguese: 'Mahāsatipaṭṭhāna', type: 'Bhuddhism' },
  { original: 'सूत्र', english: 'Sutta', portuguese: 'Sūtra', type: 'Bhuddhism' },
  { original: 'मार', english: 'Mara', portuguese: 'Māra', type: 'Bhuddhism' },
  { original: 'बुद्ध', english: 'Buddha', portuguese: 'Buda', type: 'Bhuddhism' },
  { original: 'संयोजन', english: 'Sanyogana', portuguese: 'Saṃyojana', type: 'Bhuddhism' },
  { original: 'संयोजन', english: 'Samyojana', portuguese: 'Saṃyojana', type: 'Bhuddhism' },
  { original: 'निर्वाण', english: 'Nirvana', portuguese: 'Nirvāṇa', type: 'Bhuddhism' },
  { original: 'आनन्द', english: 'Ananda', portuguese: 'Ānanda', type: 'Bhuddhism' },
  { original: '莊子', english: 'Chuang Tsu', portuguese: 'Zhuāngzǐ', type: 'Taoism' },
  { original: '莊子', english: 'Zhuang Zhou', portuguese: 'Zhuāngzǐ', type: 'Taoism' }
]

export default {
  components: {
    BackButton
  },
  data () {
    return {
      query: ''
    }
  },
  computed: {
    therms () {
      if (this.query === '') {
        return therms
      }
      return therms.filter((item) => {
        const lowerQuery = this.query.toLowerCase()
        return item.english.toLowerCase().includes(lowerQuery) || item.original.toLowerCase().includes(lowerQuery) || item.portuguese.toLowerCase().includes(lowerQuery)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/VocabularyPage.vue